import manConfirmingYellowIcon from "./svg/man-confirming-yellow-icon.svg";
import manWithCheckboxesBlueIcon from "./svg/man-with-checkboxes-blue-icon.svg";
import manWithChoicesYellowIcon from "./svg/man-with-choices-yellow-icon.svg";
import manWithProgressBlueIcon from "./svg/man-with-progress-blue-icon.svg";
import manWithProgressBarYellowIcon from "./svg/man-with-progressbar-yellow-icon.svg";
import manWithGraphsYellowIcon from "./svg/man-with-graphs-yellow-icon.svg";
import manWithMobileBlueIcon from "./svg/man-with-mobile-blue-icon.svg";
import womanWithCatYellowIcon from "./svg/woman-with-cat-yellow-icon.svg";
import womanWithCatBlueIcon from "./svg/woman-with-cat-blue-icon.svg";
import womanWithGoalsYellowIcon from "./svg/woman-with-goals-yellow-icon.svg";
import womanWithMobileRedIcon from "./svg/woman-with-mobile-red-icon.svg";
import womanWithMobileYellowIcon from "./svg/woman-with-mobile-yellow-icon.svg";
import womanWithPhoneAndNatureYellowIcon from "./svg/woman-with-phone-and-nature-yellow-icon.svg";
import coupleSittingYellowIcon from "./svg/couple-sitting-yellow-icon.svg";
import coupleYellowIcon from "./svg/couple-yellow-icon.svg";
import coupleWithVespaIcon from "./svg/couple-with-vespa-yellow.svg";
import familyBlueIcon from "./svg/family-blue-icon.svg";
import familyYellowIcon from "./svg/family-yellow-icon.svg";
import friendsYellowIcon from "./svg/friends-yellow-icon.svg";
import interviewYellowIcon from "./svg/interview-yellow-icon.svg";
import sustainabilityIcon from "./svg/sustainability.svg";

import santaHatIcon from "./svg/santa-hat.svg";
import easterBunnyFoldedEarsIcon from "./svg/easter-bunny-folded-ears.svg";
import finautIcon from "./svg/finaut.svg";
import finautDarkIcon from "./svg/finaut-dark.svg";

import norwegianFlagIcon from "./svg/norway-flag-icon.svg";
import norwegianFlagCircularIcon from "./svg/norway-flag-circular.svg";

const Illustrations = {
  norwegianFlagIcon,
  norwegianFlagCircularIcon,
  santaHatIcon,
  easterBunnyFoldedEarsIcon,
  manConfirmingYellowIcon,
  manWithCheckboxesBlueIcon,
  manWithChoicesYellowIcon,
  manWithGraphsYellowIcon,
  manWithMobileBlueIcon,
  manWithProgressBarYellowIcon,
  manWithProgressBlueIcon,
  womanWithCatBlueIcon,
  womanWithCatYellowIcon,
  womanWithGoalsYellowIcon,
  womanWithPhoneAndNatureYellowIcon,
  womanWithMobileYellowIcon,
  womanWithMobileRedIcon,
  coupleSittingYellowIcon,
  coupleWithVespaIcon,
  coupleYellowIcon,
  familyBlueIcon,
  familyYellowIcon,
  friendsYellowIcon,
  interviewYellowIcon,
  finautIcon,
  finautDarkIcon,
  sustainabilityIcon,
} as const;

export default Illustrations;
